import { func } from "prop-types";
import { useTranslation } from "react-i18next";
import { useIdleTimer } from "react-idle-timer";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { home } from "@paths";
import { useEditorWebsocket } from "@hooks";
import { useEstimateEditorStore } from "@tools";
import { Alert } from "@components";

export const TemplateEditorInactivityMonitor = ({ reloadTemplateData }) => {
  
  const {t} = useTranslation();
  const socket = useEditorWebsocket();
  const editorStore = useEstimateEditorStore();
  const navigate = useNavigate();
  const [visible, showAlert] = useState(false);
  const [isReloading, setIsReloading] = useState(false);
  
  const onIdle = () => {
    console.log("idle");
    showAlert(true);
    socket?.closeEstimate();
  }
  
  const timer = useIdleTimer({
    onIdle,
    timeout: 30*60*1000,
    throttle: 10*1000,//check every 10sec
    stopOnIdle: true,
  })
  
  useEffect(() => {
    return () => {
      timer.pause();
    }
  }, []);
  
  const handleAccept = async () => {
    if(isReloading)
      return;
    setIsReloading(true);
    const { hash, estimateData } = await reloadTemplateData();
    
    socket?.joinEstimate(estimateData.id, hash, editorStore.sortedVersions[ 0 ].key);
    setIsReloading(false);
    showAlert(false);
    timer.start();
  }
  
  const handleCancel = () => {
    if(isReloading)
      return;
    navigate(home);
  }
  
  return <Alert
    isOpen={visible}
    title={t("alerts.editor.idle.title")}
    isAcceptLoading={isReloading}
    acceptText={(
      isReloading
        ? t("alerts.editor.idle.loading_template")
        : t("alerts.editor.idle.accept")
    )}
    
    cancelText={t("alerts.editor.idle.cancel")}
    onAccept={handleAccept}
    onCancel={isReloading ? undefined : handleCancel}
  >
    {t("alerts.editor.idle.text")}
  </Alert>
}

TemplateEditorInactivityMonitor.propTypes = {
  reloadTemplateData: func.isRequired
}